<template>
  <main-layout>
    <new-client-dialog v-model="isNewClientDialogOpened" @created="clientCreated"/>
    <div>
      <v-row no-gutters align="center" class="content-header">
        <span class="font-weight-bold">Clients</span>
        <v-spacer></v-spacer>
        <v-btn :disabled="!$canWrite" dark color="primary" elevation="0" @click="$canWrite && (isNewClientDialogOpened = true)" v-if="canAddClient">
          <v-icon left>add</v-icon>
          Nouveau client
        </v-btn>
      </v-row>
      <v-col class="py-2 search-bar border-component">
        <v-text-field
          v-model="searchString"
          placeholder="Rechercher un client..."
          prepend-icon="search"
          hide-details
          dense
          clearable
          class="input-no-b-line"
        ></v-text-field>
      </v-col>
      <div class="pt-5 pb-1 pr-1">
        <v-row no-gutters justify="center" align="center">
          <h3 class="pl-2">{{ filteredClients.length }} {{ `client` | pluralize(filteredClients.length) }} {{ `trouvé` | pluralize(filteredClients.length) }}</h3>
          <v-spacer />
          <div v-if="filteredClients.length">
            <v-row no-gutters justify="center" align="center">
              <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
                <v-icon>chevron_left</v-icon>
              </v-btn>
              <div class="ml-2 primary--text font-weight-bold">
                {{ currentPage + 1 }} / {{ nbPages }}
              </div>
              <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
                <v-icon>chevron_right</v-icon>
              </v-btn>
              <v-btn class="n-white-btn n-small-btn n-icon-btn ml-2" @click="$store.dispatch(`model/client/fetchClients`)">
                <v-icon small class="accent--text font-weight-bold">refresh</v-icon>
              </v-btn>
            </v-row>
          </div>
        </v-row>
      </div>
      <v-col class="pa-0 pt-4">
        <v-list class="pa-0 border-component">
          <template v-for="(client, index) in filteredClientsPaginated">
            <v-list-item
              :key="`user-${index}`"
              :to="`/settings/clients/${client.id}`"
            >
              <v-list-item-avatar>
                <v-icon>domain</v-icon>
              </v-list-item-avatar>

              <v-row no-gutters>
                <v-col align="left">
                  <v-list-item-content>
                    <v-list-item-title>{{ client.name }}</v-list-item-title>
                  </v-list-item-content>
                </v-col>
                <div class="mt-3">
                  <v-chip small color="primary darken-1" text-color="white">Ref n°{{ client.ref }}</v-chip>
                </div>
                <!-- <v-tooltip left v-if="clientUrl(client) === null">
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" class="mt-1 ml-3">lock</v-icon>
                  </template>
                  <span>Ce client gère lui-même ses informations</span>
                </v-tooltip> -->
              </v-row>
            </v-list-item>
            <v-divider
              v-if="index + 1 < filteredClients.length"
              :key="index"
            ></v-divider>
          </template>
        </v-list>
      </v-col>
      <div class="pa-4">
        <v-row no-gutters justify="center" align="center">
          <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text" @click="previousPage">
            <v-icon>chevron_left</v-icon>
          </v-btn>
          <div class="ml-2 primary--text font-weight-bold">
            {{ currentPage + 1 }} / {{ nbPages }}
          </div>
          <v-btn class="n-white-btn n-small-btn n-icon-btn primary--text ml-2" @click="nextPage">
            <v-icon>chevron_right</v-icon>
          </v-btn>
        </v-row>
      </div>
    </div>
  </main-layout>
</template>

<script>
import { mapState } from 'vuex';
import _ from 'lodash';
import MainLayout from '@/views/settings/MainLayout.vue';
import NewClientDialog from '@/components/NewClientDialog.vue';

const PAGE_SIZE = 25;

export default {
  name: `SettingsClientsList`,
  data: () => ({
    isNewUserDialogOpened: false,
    isUserDialogOpened: false,
    isNewClientDialogOpened: false,
    currentPage: 0,
  }),
  computed: {
    ...mapState(`model/client`, [`company`]),
    ...mapState(`ui/clientsList`, {
      storeSearchString: `searchString`,
    }),
    ...mapState(`ui/clientsList`, [
      `isKeepingPreviousState`,
    ]),
    ...mapState(`ui/mainLayout`, [`isDemoApp`]),
    canAddClient() {
      return [`aba`, `sushi-robots`, `techni-froid-cuisines`].indexOf(this.company.slug) === -1 || this.isDemoApp;
    },
    searchString: {
      get() {
        return this.storeSearchString;
      },
      set(searchString) {
        this.setSearchString(searchString);
      },
    },
    ...mapState(`model/client`, {
      storeClients: `clients`,
    }),
    flavoredClients() {
      return _.chain(this.storeClients)
        .map(client => ({
          ...client,
          $searchString: _.toLower(`${client.name} ${client.address || ``} ${client.postalCode || ``} ${client.city || ``}`.replace(/ {2}/g, ` `)),
        }))
        .sortBy(`$searchString`)
        .value();
    },
    filteredClients() {
      let clients = this.flavoredClients;
      if (this.searchString) {
        const searchString = _.lowerCase(this.searchString);
        clients = _.filter(clients, client =>
          client.$searchString.indexOf(searchString) !== -1
        );
      }
      return clients;
    },
    filteredClientsPaginated() {
      const firstIndex = this.currentPage * PAGE_SIZE;
      return this.filteredClients.slice(firstIndex, firstIndex + PAGE_SIZE);
    },
    nbPages() {
      return Math.ceil(this.filteredClients.length / PAGE_SIZE);
    },
  },
  methods: {
    setSearchString(searchString) {
      this.$store.commit(`ui/clientsList/SET_SEARCH_STRING`, searchString);
    },
    previousPage() {
      if (this.currentPage > 0) {
        this.currentPage -= 1;
      }
    },
    nextPage() {
      const newPageIndex = (this.currentPage + 1) * PAGE_SIZE;
      if (newPageIndex < this.filteredClients.length) {
        this.currentPage += 1;
      }
    },
    clientUrl(client) {
      return client.slug === `` ? `/settings/clients/${client.id}` : null;
    },
    clientCreated() {
      this.$store.dispatch(`showSnackbar`, {
        color: `success`,
        message: `Client créé avec succès`,
      });
    },
  },
  watch: {
    searchString() {
      this.currentPage = 0;
    },
  },
  beforeMount() {
    if (!this.isKeepingPreviousState) {
      this.setSearchString(``);
      this.$store.commit(`ui/clientsList/SET_KEEPING_PREVIOUS_STATE`, false);
      this.$store.dispatch(`model/client/fetchClients`);
    } else if (!this.storeClients.length) {
      this.$store.dispatch(`model/client/fetchClients`);
    }
  },
  components: {
    MainLayout,
    NewClientDialog,
  },
};
</script>

<style lang="scss">
  .search-bar {
    background: white;
  }
  .border-component {
    border: 1px solid #DDDDDD !important;
    border-radius: 6px !important;
  }
  .v-input__slot::before {
    display: none
  }
</style>
